import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ParentContainor from '../../components/base/ParentContainor';
import LeaderboardScreen from '../../components/LeaderboardScreen';
import { ROUTE_ENUM } from '../../routes/RoutesConstant';
import { logger } from '../../utils/logger';
import { TEXT_LABELS } from '../../constants/TextLabelConstants';
import { PAGE_OUTER_PADDING } from '../../constants/housieLiveStyles';
import { handleFireworksConfettiClick } from '../../components/base/ConfettiView';

const RapHousieLeaderBoard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { leaderBoardApiData, roomName: roomNameFromState } = location.state || {};

  const [showBoard, setShowBoard] = useState(false);

  useEffect(() => {
    logger.log('Rapchick RapHousieLeaderBoard leaderBoardApiData : ', leaderBoardApiData);
    handleFireworksConfettiClick({
      onBlastFinished: () => setShowBoard(true),
    });
    return () => setShowBoard(false);
  }, [leaderBoardApiData]);

  const sortedUsers = useMemo(() => {
    const users = leaderBoardApiData?.users || [];
    return [...users]
      .sort((a, b) => (b?.points || 0) - (a?.points || 0))
      .map((user, index) => ({
        ...user,
        rank: user?.rank ?? index + 1,
      }));
  }, [leaderBoardApiData]);

  const hasWinners = sortedUsers.some((player) => (player?.points || 0) > 0);

  const roomName =
    roomNameFromState ||
    leaderBoardApiData?.roomName ||
    leaderBoardApiData?.game?.roomName ||
    'Room';

  const headerTitle = `${roomName} - ${TEXT_LABELS.RAP_HOUSIE_LEADERBOARD_TITLE}`;

  return (
    <ParentContainor
      route={ROUTE_ENUM.SELECT_RAP_HOUSIE_GAME}
      parentContainorStyle={{ justifyContent: 'flex-start' }}
      isShowHeader={false}
      showCopyRightText
      isBreadcrumbVisible={false}
      padding={PAGE_OUTER_PADDING}
      showBlurredBg
    >
      <LeaderboardScreen
        headerTitle={headerTitle}
        onBack={() => navigate(ROUTE_ENUM.SELECT_GAME.routePath)}
        columns={{
          rank: TEXT_LABELS.RAP_HOUSIE_LEADERBOARD_COL_RANK,
          player: TEXT_LABELS.RAP_HOUSIE_LEADERBOARD_COL_PLAYER,
          points: TEXT_LABELS.RAP_HOUSIE_LEADERBOARD_COL_GAME_POINTS,
          won: TEXT_LABELS.RAP_HOUSIE_LEADERBOARD_COL_WON,
        }}
        players={sortedUsers}
        showBoard={showBoard}
        hasWinners={hasWinners}
        emptyLabel={TEXT_LABELS.RAP_HOUSIE_LEADERBOARD_NO_WINNERS}
        congratsLabel={
          hasWinners
            ? TEXT_LABELS.RAP_HOUSIE_LEADERBOARD_SUBTITLE
            : TEXT_LABELS.RAP_HOUSIE_LEADERBOARD_NO_WINNERS
        }
      />
    </ParentContainor>
  );
};

export default RapHousieLeaderBoard;
